"use strict";
/**
 *
 * TextField
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ palette, spacing, shadows, shape, typography }) => ({
    root: {
        display: 'flex',
        textAlign: 'left',
        position: 'relative',
    },
    input: {
        width: '100%',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        border: `1px solid ${palette.dark('border')}`,
        borderRadius: shape.borderRadius,
        padding: spacing(0.35, 1),
        textAlign: 'inherit',
        position: 'relative',
        background: 'transparent',
        zIndex: 1,
        outline: 'none',
        '&::placeholder': {
            color: palette.textSecondary,
        },
        '&:invalid': {
            color: palette.warning,
            borderColor: palette.warning,
            '& + $label': {
                color: palette.warning,
            },
        },
        '&:hover': {
            borderColor: palette.darkest('border'),
        },
        '&:focus': {
            boxShadow: shadows[5],
            borderColor: palette.darkest('border'),
            '& + $label': {
                zIndex: 1,
            },
            backgroundColor: palette.surface,
            '&:invalid': {
                backgroundColor: palette.lightest('warning'),
            },
        },
        '&$disabled': {
            cursor: 'not-allowed',
            color: palette.textSecondary,
            borderColor: palette.border,
        },
    },
    inputWithLabel: {
        padding: spacing(2, 1, 0.35, 1),
    },
    inputDense: {
        padding: spacing(0, 0.35),
    },
    inputDenseWithLabel: {
        padding: spacing(1.35, 0.35, 0, 0.35),
    },
    label: Object.assign({ display: 'inline-flex', alignItems: 'flex-start', position: 'absolute', lineHeight: 1, top: 0, bottom: 0, left: 0, color: palette.dark('textSecondary'), paddingTop: spacing(0.5), paddingLeft: spacing(1) }, typography.label),
    labelDense: {
        paddingLeft: spacing(0.35),
    },
    disabled: {},
}));
exports.textFieldClassName = styles_1.generateStaticClassName('TextField');
const TextField = React.forwardRef(function TextField(props, ref) {
    const { classes, className, label, dense, disabled } = props, rest = __rest(props, ["classes", "className", "label", "dense", "disabled"]);
    return (React.createElement("div", { className: clsx_1.default(classes.root, exports.textFieldClassName, className) },
        React.createElement("input", Object.assign({}, rest, { ref: ref, disabled: disabled, className: clsx_1.default(classes.input, label && classes.inputWithLabel, dense && classes.inputDense, dense && label && classes.inputDenseWithLabel, disabled && classes.disabled) })),
        label && (React.createElement("label", { className: clsx_1.default(classes.label, dense && classes.labelDense) }, label))));
});
if (process.env.NODE_ENV !== 'production') {
    TextField.displayName = 'TextField';
}
const Styled = styles_1.withStyles(styles)(TextField);
exports.TextField = Styled;
